import { create } from 'zustand';

/**
 * FRONT-3003: whether the Pro Builder window is showing. Two separate facts on
 * purpose. `open` is only visibility — closing HIDES the window, it never
 * unmounts it, because the terminal inside it is a running Claude Code.
 * `everOpened` is the mount latch: the app shell mounts the window only after
 * the first open request, so nobody who never opens Pro Builder gets a
 * terminal session, and it stays mounted afterwards (until the tab closes).
 */
interface ProBuilderOpenState {
  open: boolean;
  everOpened: boolean;
  openProBuilder: () => void;
  closeProBuilder: () => void;
}

/**
 * The window's open EDGE (hidden -> shown), which the full-screen overlays
 * (the desktop operator panel, Settings, the chat window) close on
 * (`use-close-on-pro-builder-open.ts`). Not "is open": a surface that mounts
 * while the window is already open reads that as the state it found, never as
 * the window opening over it — the caller seeds `previous` with the mount-time
 * value, the same rule the operator-panel request watcher uses.
 */
export function isProBuilderOpenEdge(previous: boolean, next: boolean): boolean {
  return !previous && next;
}

export const useProBuilderOpenStore = create<ProBuilderOpenState>((set) => ({
  open: false,
  everOpened: false,
  openProBuilder: () => set({ open: true, everOpened: true }),
  closeProBuilder: () => set({ open: false }),
}));
